module.exports = __webpack_public_path__ + "img/num_27.7486b4ab.png";